import { render, staticRenderFns } from "./revolva.model.vue?vue&type=template&id=5f7b5272&scoped=true&"
import script from "./revolva.model.vue?vue&type=script&lang=ts&"
export * from "./revolva.model.vue?vue&type=script&lang=ts&"
import style0 from "./revolva.model.vue?vue&type=style&index=0&id=5f7b5272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7b5272",
  null
  
)

export default component.exports